import { Group, Image, Stack, Text } from '@mantine/core';
import { IconChevronsUp } from '@tabler/icons-react';
import Link from 'next/link';
export const HeaderStatus = () => {
  return <Group mb={5} visibleFrom="sm" h={80} ml={8} wrap="nowrap">
      <Link href="/">
        <Image src="/apisus.png" visibleFrom="md" alt="Prime logo" width={49} height={49} />
        <Image src="/assets/logo-tablet.svg" hiddenFrom="md" alt="Prime logo" />
      </Link>
      <Stack gap={-1} maw={200}>
        <Group align="center" justify="space-between" wrap="nowrap">
          <Text tt="uppercase" fw="bold" c="var(--text-prime)" fz={{
          base: 'sm',
          md: 'md'
        }}>
            {'Apisus Co'}
          </Text>
          <Text tt="uppercase" fw="bold" c="dimmed" fz={{
          base: 'sm',
          md: 'md'
        }}>
            {'(APISUS)'}
          </Text>
        </Group>
        <Group align="center" justify="space-between" wrap="nowrap">
          <Text tt="uppercase" fw="bold" c="white" fz={{
          base: 'sm',
          md: 'md'
        }}>
            {'$0.129'}
          </Text>
          <Group gap={1}>
            <IconChevronsUp size={20} color="var(--mantine-color-prime-8)" />
            <Text tt="uppercase" fw="bold" c="var(--text-green)" fz={{
            base: 'sm',
            md: 'md'
          }}>
              {'12%'}
            </Text>
          </Group>
        </Group>
      </Stack>
    </Group>;
};